module.exports = __webpack_public_path__ + "static/media/logo-new-black.37fa9519.png";